<template>
  <v-layout
    ma-0
    pa-0
    pb-2
    row
    wrap
  >
    <v-flex
      xs12
      class="align-start elevation-2 mt-1"
      :class="{ 'mx-1': $vuetify.breakpoint.xsOnly }"
    >
      <v-layout row wrap class="px-4 py-3">
        <v-flex
          xs12
          md12
          sm12
          lg12
          :class="{'mb-3' : !isSummary}"
        >
          <v-layout row wrap>
            <v-flex
              xs6
              md4
              class="pa-0 ma-0"
              v-for="field in Object.values(customFields)"
              :key="field.value"
            >
              <v-checkbox
                class="px-0 py-1 ma-0 form-fields"
                :class="{'form-fields-disabled':(field.value == leadFormEnabledFields.NAME.value || field.value == leadFormEnabledFields.CONTACT_NUMBER.value)}"
                color="primary"
                v-model="formFields"
                :value="field.value"
                :label="field.label"
                hide-details
                name="formFields"
                :disabled="(field.value == leadFormEnabledFields.NAME.value || field.value == leadFormEnabledFields.CONTACT_NUMBER.value)"
              />
            </v-flex>
          </v-layout>
        </v-flex>
        <slot name="button" />
      </v-layout>
    </v-flex>
  </v-layout>
</template>
<script>
import {
  VLayout,
  VFlex,
  VCheckbox
} from 'vuetify/lib';
import {
  leadFormEnabledFields,
  leadFormEnabledFieldsForXs
} from 'Features/bizgainOnboarding/constants';

export default {
  data() {
    return {
      leadFormEnabledFields,
      leadFormEnabledFieldsForXs,
      customFields: null
    };
  },
  props: {
    prefilledFields: {
      type: Array,
      default: () => [1, 2, 3]
    },
    isSummary: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    formFields: {
      get() {
        return this.prefilledFields && this.prefilledFields.length > 0 ? this.prefilledFields : [1, 2, 3];
      },
      set(value) {
        this.$emit('formFieldsUpdate', value);
      }
    }
  },
  created(){
    this.customFields = this.$vuetify.breakpoint.width < 730 ? this.leadFormEnabledFieldsForXs : this.leadFormEnabledFields;
  },
  components: {
    VLayout,
    VFlex,
    VCheckbox
  }
};
</script>
<style lang="scss" scoped>
.label {
  padding-top: 2px !important;
  padding-bottom: 2px !important;
  padding-left: 0px !important;
}

::v-deep .theme--light.v-input--selection-controls.v-input--is-disabled .v-icon {
  color: var(--v-primary-variation-1-base) !important;
}
</style>
